import localization from 'localization';
import { TaskStatusEnum } from 'domains-work-order-constants';

const VALID_TASK_STATUSES = new Set<string>(Object.values(TaskStatusEnum));

/**
 * Type predicate to check if a value is a valid TaskStatusEnum
 */
function isValidTaskStatus(
  status: string | TaskStatusEnum | undefined
): status is TaskStatusEnum {
  if (!status) return false;

  return VALID_TASK_STATUSES.has(status);
}

/**
 * Gets the translated status label for tasks
 * @param status - The task status (enum value or string)
 * @returns The translated label, or undefined if status is invalid or falsy
 */
export function getTaskStatusLabel(
  status?: string | TaskStatusEnum
): string | undefined {
  if (!isValidTaskStatus(status)) {
    return undefined;
  }

  const statusKey = status.replace(/\s/g, '').toLowerCase();
  const i18n = localization.cloneInstance();

  return i18n.t(`shared.workOrders.tasks.status.${statusKey}`);
}
